import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../baseQuery";

// Custom base query for axios that properly handles interceptors

export const discoverApi = createApi({
  reducerPath: "discoverApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Discover"],
  endpoints: (builder) => ({
    getRecentContentForCreator: builder.query({
      query: ({
        wishlink_username,
        pagination = { page: 1, rows_per_page: 10 },
      }) => ({
        url: `getRecentContentForCreator`,
        method: "POST",
        body: {
          wishlink_username,
          pagination,
        },
      }),
      keepUnusedDataFor: 0,
    }),
    getSimilarCreators: builder.query({
      query: ({
        wishlink_username,
        pagination = { page: 1, rows_per_page: 10 },
      }) => ({
        url: `getSimilarCreators`,
        method: "POST",
        body: {
          wishlink_username,
          pagination,
        },
      }),
      keepUnusedDataFor: 0,
    }),
    getBrands: builder.query({
      query: () => ({
        url: `/getAllBrandsNameWithId`,
        method: "GET",
      }),
    }),
    getFilterSuggestions: builder.query({
      query: (query) => ({
        url: `get-filter-suggestions`,
        method: "POST",
        body: {
          query,
        },
      }),
      keepUnusedDataFor: 0,
    }),

    getRecentIGPostsForCreator: builder.query({
      query: ({ wishlink_username }) => ({
        url: `getRecentIGPostsForCreator`,
        method: "GET",
        params: { wishlink_username },
      }),
      keepUnusedDataFor: 0,
    }),
    getCreatorDemographicsFilters: builder.query({
      query: ({ state_filter = "", city_filter = "" }) => ({
        url: `get-creator-demographics`,
        method: "POST",
        body: { state_filter, city_filter },
      }),
      keepUnusedDataFor: 0,
    }),
    getRecentCreatorProfiles: builder.query({
      query: () => ({
        url: `getRecentCreatorProfiles`,
        method: "GET",
      }),
      keepUnusedDataFor: 0,
      providesTags: ["Discover"],
    }),

    getRecentFilters: builder.query({
      query: () => ({
        url: `get-recent-filters`,
        method: "GET",
      }),
      keepUnusedDataFor: 0,
      providesTags: ["Discover"],
    }),
    createRecentFilter: builder.mutation({
      query: ({ category, subcategory, filter_obj }) => ({
        url: `create-recent-filter`,
        method: "POST",
        body: { category, subcategory, filter_obj },
      }),
      invalidatesTags: ["Discover"],
    }),

    createRecentCreatorProfileChecked: builder.mutation({
      query: ({ creator_id, source, icm_username, brand_id }) => ({
        url: `createRecentCreatorProfileChecked`,
        method: "POST",
        body: { creator_id, source, icm_username },
        params: brand_id ? { brand_id } : {},
      }),
      invalidatesTags: ["Discover"],
    }),
    clearRecentFiltersOrProfiles: builder.mutation({
      query: ({ clear_profile, clear_filter }) => ({
        url: `clear-recent-filters-or-profiles`,
        method: "POST",
        body: { clear_profile, clear_filter },
      }),
      invalidatesTags: ["Discover"],
    }),
  }),
});

export const {
  useLazyGetRecentContentForCreatorQuery,
  useLazyGetSimilarCreatorsQuery,
  useGetBrandsQuery,
  useLazyGetFilterSuggestionsQuery,
  useLazyGetRecentIGPostsForCreatorQuery,
  useLazyGetCreatorDemographicsFiltersQuery,
  useGetRecentCreatorProfilesQuery,
  useGetRecentFiltersQuery,
  useCreateRecentFilterMutation,
  useCreateRecentCreatorProfileCheckedMutation,
  useClearRecentFiltersOrProfilesMutation,
} = discoverApi;
